function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Track");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  x: "-3.1%",
  y: "-5.2%",
  width: "106.1%",
  height: "110.5%",
  filterUnits: "objectBoundingBox",
  id: "track-filter-1"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), React.createElement("path", {
  d: "M23.7312805,1.66328105 C21.4391565,3.13796602 18.4667801,3.13796602 16.1746561,1.66328105 C14.5565359,0.622026212 12.6336512,0.013349421 10.5696035,0.000284030234 C4.80520992,-0.0363558699 0.13461676,4.49279024 0.00282673169,10.2554796 C-0.13265569,16.167853 4.61945415,21.0031837 10.5011522,21.0031837 C12.5799695,21.0031837 14.5173397,20.3993354 16.1482413,19.3572285 C18.4772893,17.868342 21.4283634,17.868342 23.7579794,19.3572285 C25.3883129,20.3993354 27.3256831,21.0031837 29.4045004,21.0031837 C35.2859145,21.0031837 40.0385924,16.167569 39.9031099,10.2554796 C39.7716039,4.51579669 35.1376507,0.000284030234 29.4056365,1.95399252e-14 C29.3826301,1.95399252e-14 29.3596236,0.000284030234 29.3363331,0.000284030234 C27.2722854,0.013349421 25.3494008,0.622310242 23.7312805,1.66328105 Z",
  id: "track-path-2"
}), React.createElement("filter", {
  x: "-3.8%",
  y: "-7.1%",
  width: "107.5%",
  height: "114.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowInnerInner1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home",
  transform: "translate(-291.000000, -132.000000)"
}, React.createElement("g", {
  id: "Card",
  filter: "url(#track-filter-1)",
  transform: "translate(16.000000, 120.000000)"
}, React.createElement("g", {
  id: "Switch-Button",
  transform: "translate(283.000000, 20.000000)"
}, React.createElement("g", {
  id: "Track",
  transform: "translate(-0.000000, 0.000114)"
}, React.createElement("g", {
  id: "Fill-7"
}, React.createElement("use", {
  fill: "#F7F7F7",
  fillRule: "evenodd",
  xlinkHref: "#track-path-2"
}), React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#track-path-2"
})))))));

var SvgTrack = function SvgTrack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "56px",
    height: "38px",
    viewBox: "0 0 56 38",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/track.5d3ca179.svg";
export { ForwardRef as ReactComponent };